import { useAnalytics, useSignupUrl } from './useAuth'

// Where a signup CTA was clicked from. Lets the funnel attribute conversions to
// the surface that drove them — the gated History/Schedules nav items, the
// header button, or the anonymous guest banner.
export type SignupOrigin =
  | 'header_button'
  | 'history'
  | 'schedule'
  | 'guest_banner'
  | 'intent_map_mode'

interface SignupClick {
  /** The conversion target (injected per shell; defaults to VWAM_SIGNUP_URL). */
  signupUrl: string
  /** onClick handler for a signup CTA; fires signup_clicked with its origin. */
  onSignupClick: (origin: SignupOrigin) => void
}

// Centralizes the signup_clicked event so every CTA fires it consistently while
// still naming its own origin. The navigation itself stays a plain <a href>, so
// the event fires on the same click that follows the link (analytics.track is
// fire-and-forget — the lazy mixpanel send doesn't block the navigation).
export function useSignupClick(): SignupClick {
  const signupUrl = useSignupUrl()
  const analytics = useAnalytics()

  return {
    signupUrl,
    onSignupClick: (origin) => analytics.track('signup_clicked', { origin }),
  }
}
